// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fxVx","badges":"styles_badges__2Nl6U"};